import ReadyToVerifyModal from './ready-to-verify-modal';

export default ReadyToVerifyModal;
